import { useQuery } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'
import type { MiProgramacion } from '@/lib/supabase/tipos-bd'
import { conRespaldo } from '@/lib/campo/loUltimoQueSeSupo'

/**
 * La programación del operario, para su calendario.
 *
 * Sale de una función que devuelve solo lo suyo, sin precios. Es de mirar, no
 * de tocar: el técnico no programa ni reprograma nada.
 */
export function useMiProgramacion() {
  const consulta = useQuery({
    queryKey: ['mi-programacion'],
    staleTime: 60 * 1000,
    // Lo que se vio la última vez, para que la pantalla abra en la obra.
    queryFn: () =>
      conRespaldo<MiProgramacion[]>('mi-programacion', async () => {
        const { data, error } = await supabase.rpc('fn_mi_programacion')

        if (error) throw new Error(mensajeDeError(error))

        return ((data ?? []) as unknown as MiProgramacion[]).map((fila) => ({
          ...fila,
          horas_asignadas: fila.horas_asignadas === null ? null : Number(fila.horas_asignadas),
        }))
      }),
  })

  return {
    programacion: consulta.data ?? [],
    cargando: consulta.isLoading,
    error: consulta.error?.message ?? null,
  }
}
